module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: _vm.popupActive ? 'popupActive' : ''
  }, [(_vm.popupActive) ? _c('a', {
    staticClass: "close button",
    on: {
      "click": function($event) {
        _vm.popupActive = false
      }
    }
  }, [_vm._v("Close X")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "title top"
  }, [_vm._v("\n    " + _vm._s(_vm.face.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "face"
  }, [_c('div', {
    staticClass: "imgContainer"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.face.imageName),
      expression: "face.imageName"
    }],
    on: {
      "click": function($event) {
        _vm.popupActive = !_vm.popupActive
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "description",
    class: _vm.titleDescription ? 'titleDescription' : ''
  }, [_vm._v("\n      " + _vm._s(_vm.face.description) + "\n    ")])]), _vm._v(" "), _c('p', {
    staticClass: "title bottom"
  }, [_vm._v("\n    " + _vm._s(_vm.face.title) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddf0b578"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Face.vue
// module id = 14
// module chunks = 0 1 2 3 4